import { render, staticRenderFns } from "./MaterialPriceEdit.vue?vue&type=template&id=4d1ae295&"
import script from "./MaterialPriceEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialPriceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports